import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Popover,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  addAdvertReport,
  getRecruitmentReportAdverts,
  deleteRecruitmentReportAdvert,
  onConfirmReportedAdvert,
} from "../../../store/recruitment/actions";
import { Add as AddIcon } from "@mui/icons-material";
import PreLoader from "../../common/components/PreLoader";
import NoRecordMessage from "../../common/components/NoRecordMessage";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import RemoveIcon from "@mui/icons-material/Remove";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import AdvertisementReportDialog from "./AdvertisementReportDialog";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AdvertisementReport from "./AdvertisementReport";
import moment from "moment";
import { showError } from "../../toastify";
const RecruitmentReportAdvert = (props) => {
  const {
    recruitmentReport,
    addAdvertReport,
    getRecruitmentReportAdverts,
    recruitmentReportAdverts,
    deleteRecruitmentReportAdvert,
    onConfirmReportedAdvert,
  } = props;
  const [searchTeam, setSearchTeam] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showAdvertisementReport, setShowAdvertisementReport] = useState(false);
  const [reportAdvert, setReportAdvert] = useState(null);
  const [confirmRemoveReportAdvert, setConfirmRemoveReportAdvert] =
    useState(false);

  const { hasPermissions } = useRequiredAuth();
  useEffect(() => {
    const reportId = +recruitmentReport?.id;
    getRecruitmentReportAdverts(reportId, setIsLoading);
  }, [recruitmentReport]);

  const onSubmit = () => {
    const params = {
      advertisementId: searchTeam,
      reportId: +recruitmentReport?.id,
    };
    addAdvertReport(params, setIsSearching, setSearchTeam);
  };
  return (
    <>
      {[7].includes(+recruitmentReport.statusId) && (
        <fieldset className={`form-group border p-2`}>
          <legend
            className="w-auto px-2"
            style={{
              fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
              fontWeight: 400,
              fontSize: "0.82rem",
              lineHeight: "1em",
              letterSpacing: "0.00938em",
              color: "rgba(0, 0, 0, 0.6)",
            }}
          >
            <span className="ml-1">Assign Advertisement to Report</span>
          </legend>
          <div className="d-flex justify-content-end mb-2">
            <TextField
              size="small"
              name="searchTeam"
              label={`Enter Advertisement ID`}
              fullWidth
              placeholder={`Enter Advertisement ID`}
              value={searchTeam}
              onChange={(e) => {
                const searchTeam = e.target.value;
                setSearchTeam(searchTeam);
              }}
            />
            <Button
              className="ml-2 px-3"
              color="primary"
              variant="contained"
              disabled={isSearching || !searchTeam}
              onClick={() => onSubmit()}
              startIcon={<AddIcon />}
              style={{
                float: "right",
              }}
              size="md"
            >
              Assign
            </Button>
          </div>
        </fieldset>
      )}

      <div className="mt-3">
        <PreLoader isLoading={isLoading && !recruitmentReportAdverts.length} />

        <NoRecordMessage
          isEmpty={!isLoading && !recruitmentReportAdverts.length}
          title={"No Advertisement(s) Assigned!"}
        />
        {!isLoading && !!recruitmentReportAdverts.length && (
          <div className="mt-0">
            {showAdvertisementReport && reportAdvert && (
              <AdvertisementReportDialog
                showAdvertisementReport={showAdvertisementReport}
                setShowAdvertisementReport={setShowAdvertisementReport}
                advertisement={reportAdvert}
              />
            )}

            {recruitmentReportAdverts.map((advert, index) => (
              <ReportAdvertAccordion
                key={index}
                index={index + 1}
                advert={advert}
                defaultExpanded={[7].includes(+recruitmentReport?.statusId) && recruitmentReportAdverts.length === 1}
                setReportAdvert={setReportAdvert}
                reportAdvert={reportAdvert}
                setShowAdvertisementReport={setShowAdvertisementReport}
                recruitmentReport={recruitmentReport}
                confirmRemoveReportAdvert={confirmRemoveReportAdvert}
                setConfirmRemoveReportAdvert={setConfirmRemoveReportAdvert}
                hasPermissions={hasPermissions}
                onConfirmReportedAdvert={onConfirmReportedAdvert}
              />
            ))}

            {confirmRemoveReportAdvert && (
              <ConfirmationDialog
                confirmationDialog={confirmRemoveReportAdvert}
                message={`Are you sure you want to remove this advertisement @${reportAdvert.positionName}?`}
                setConfirmationDialog={setConfirmRemoveReportAdvert}
                onYes={() => {
                  deleteRecruitmentReportAdvert(
                    reportAdvert?.id,
                    setConfirmRemoveReportAdvert,
                    setReportAdvert
                  );
                }}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = ({
  loading,
  user,
  recruitmentReport,
  recruitmentReportAdverts,
}) => {
  return {
    loading,
    user,
    recruitmentReport,
    recruitmentReportAdverts,
  };
};
export default connect(mapStateToProps, {
  addAdvertReport,
  getRecruitmentReportAdverts,
  deleteRecruitmentReportAdvert,
  onConfirmReportedAdvert,
})(RecruitmentReportAdvert);

const ReportAdvertAccordion = (props) => {
  const {
    advert,
    defaultExpanded,
    setReportAdvert,
    reportAdvert,
    setShowAdvertisementReport,
    recruitmentReport,
    confirmRemoveReportAdvert,
    setConfirmRemoveReportAdvert,
    hasPermissions,
    index,
    onConfirmReportedAdvert,
  } = props;
  const [more, setMore] = useState(defaultExpanded);
  const [showApproverDetailDialog, setShowApproverDetailDialog] =
    useState(false);
  return (
    <div>
      <Accordion
        className="mb-1 border border-primary"
        defaultExpanded={defaultExpanded}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`advert-${advert.id}`}
          id={`advert-${advert.id}`}
          onClick={() => setMore(!more)}
        >
          <Typography component="span" className="w-100">
            <div className="d-flex justify-content-between align-items-center flex-wrap w-100">
              {/* Left: Position Name */}
              <div className="flex-grow-1 text-left">
                <strong className="mr-1">{index}.</strong>{" "}
                <strong>
                  {advert.positionName} ({advert.levelName}.{advert.scaleName})
                </strong>{" "}
                - {advert.employeeGroupName} -
                <span
                  className={`ml-1 font-weight-bold text-uppercase text-${
                    [3, 4, 5].includes(+advert.statusId)
                      ? "danger"
                      : [1].includes(+advert.statusId)
                      ? "primary"
                      : "success"
                  }`}
                >
                  {advert.statusName}
                </span>{" "}
                <br />
                <small
                  className="pl-4"
                  style={{ fontStyle: "italic", fontSize: "13px" }}
                >
                  {" "}
                  - <strong>NoOfPosts: {advert.numberOfPosts}</strong> -
                  Published on,{" "}
                  {moment(advert.openingDate).format("DD/MM/YYYY")}
                </small>
              </div>

              {/* Right: Status Name */}
              <div className="text-right  mr-2">
                <Button
                  type="button"
                  className="btn-sm"
                  onClick={() => setMore(!more)}
                >
                  View {more ? "less" : "more"}...
                </Button>
              </div>
            </div>
          </Typography>
        </AccordionSummary>

        <AccordionDetails>
          <div style={{ height: "50vh" }} className="mb-2">
            <AdvertisementReport
              viewLess={true}
              details={{
                ...advert,
                advertisementId: advert?.advertismentId,
                reportId: +advert?.reportId,
                reportStatusId: +advert?.statusId,
              }}
            />
          </div>
        </AccordionDetails>
        <Divider />
        <AccordionActions>
          <div className="d-flex justify-content-between align-items-center flex-wrap w-100">
            <div className="flex-grow-1 text-left">
              {[7].includes(+recruitmentReport.statusId) && (
                <Button
                  disabled={
                    !hasPermissions(["IS_CBM", "IS_HR"]) ||
                    (confirmRemoveReportAdvert &&
                      reportAdvert?.id === advert.id)
                  }
                  onClick={() => {
                    setReportAdvert(advert);
                    setConfirmRemoveReportAdvert(true);
                  }}
                  color="error"
                  className="btn btn-danger btn-sm"
                >
                  {confirmRemoveReportAdvert &&
                  reportAdvert?.id === advert.id ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                      ></span>
                      <span className="sr-only">Loading...</span>
                    </>
                  ) : (
                    <>
                      <RemoveIcon /> Remove Advert
                    </>
                  )}
                </Button>
              )}
              {[2].includes(+recruitmentReport.statusId) &&
                [1].includes(+advert.statusId) &&
                hasPermissions(["IS_NPSC", "IS_NPSC_APPROVER", "IS_NPSC_SUPERVISOR"]) && (
                  <>
                    <ConfirmPositionButton
                      advert={advert}
                      disabled={false}
                      onConfirmReportedAdvert={onConfirmReportedAdvert}
                    />
                  </>
                )}
              {advert.approverName && (
                <small
                  className="pl-4"
                  style={{ fontStyle: "italic", fontSize: "13px" }}
                >
                  Confirmed by {advert.approverName},{" "}
                  <button
                    onClick={() => {
                      setShowApproverDetailDialog(true);
                    }}
                    className="btn badge badge-pill text-warning font-weight-bold text-uppercase text-underline cursor-pointer"
                    aria-label="View your appeal for written exam"
                  >
                    <span aria-hidden="true">See details</span>
                  </button>
                </small>
              )}
            </div>
            <div className="text-right  mr-2">
              <Button
                type="button"
                onClick={() => {
                  setReportAdvert(advert);
                  setShowAdvertisementReport(true);
                }}
                color="primary"
                variant="contained"
                className=" m-2 btn-sm"
              >
                Open full report ... <OpenInNewIcon />
              </Button>
            </div>
          </div>
        </AccordionActions>
      </Accordion>

      {showApproverDetailDialog && (
        <ConfirmationDialog
          disabled={true}
          confirmationDialog={showApproverDetailDialog}
          message={
            <>
              <div style={{ minWidth: "200px" }} className="w-100  float-start">
                <div className="d-flex flex-row justify-content-start mt-0 mr-3 w-100 float-start">
                  <div
                    className="card  w-100"
                    style={{
                      backgroundColor: "#fff",
                      borderLeft: "2px solid #3f51b5",
                      borderLeft: "2px solid #3f51b5",
                      borderRadius: "4px",
                    }}
                  >
                    <div className="card-body w-100 text-left">
                      {advert.reason && (
                        <p className="small pb-3 ms-2 mb-0 rounded-3 text-left">
                          Reason: {advert.reason}
                        </p>
                      )}

                      <p className="small p-0 ms-2 mb-0 rounded-3 text-left">
                        Confirmed by: {advert.approverName}
                      </p>
                      <p className="small p-0 ms-2 mb-0 rounded-3 text-left">
                        Confirmed on: {moment(advert.statusOn).format("llll")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </>
          }
          setConfirmationDialog={setShowApproverDetailDialog}
          onYes={() => {
            setShowApproverDetailDialog(false);
          }}
        />
      )}
      {/* <Divider /> */}
    </div>
  );
};

const ConfirmPositionButton = (props) => {
  const { advert, disabled, onConfirmReportedAdvert } = props;

  const decisions = [
    { id: 2, name: "Confirm the advertised position." },
    { id: 3, name: "Cancel the written exam." },
    { id: 4, name: "Cancel the oral exam." },
    { id: 5, name: "Cancel the advertised position." },
  ];

  const [decision, setDecision] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    id: +advert?.id,
    reason: "",
    statusId: "",
  });

  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover-" + advert?.id : undefined;
  const [errors, setErrors] = useState({
    hasError: false,
    statusIdError: false,
    reasonHasError: false,
  });
  const formValidator = () => {
    const error = {
      hasError: false,
      statusIdError: false,
      reasonHasError: false,
    };

    if (!decision) {
      error.statusIdError = true;
      error.hasError = true;
    }

    if (!formData.reason) {
      error.reasonHasError = true;
      error.hasError = true;
    }

    setErrors(error);

    if (error.hasError) {
      showError("Please fill the required field");
      return true;
    }
    return false;
  };
  // console.log(formData, decision);
  return (
    <>
      <Button
        variant="contained"
        color="warning"
        aria-describedby={id}
        disabled={disabled || isLoading}
        onClick={handleOpen}
        style={{ marginRight: "10px", textTransform: "none" }}
        startIcon={<span className="material-icons mr-1">done_all</span>}
      >
        Approve position
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "left",
          horizontal: "top",
        }}
      >
        <Card sx={{ maxWidth: 400, minWidth: 200 }}>
          <CardHeader
            sx={true}
            action={
              <IconButton aria-label="close" onClick={handleClose}>
                <span className="material-icons">close</span>
              </IconButton>
            }
            subheader={<>Make a decision on {advert?.positionName}</>}
          />
          <Divider />
          <CardContent>
            <div className="card service-card valid  mb-2 mt-1">
              <FormControl className="mx-4">
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  // defaultValue="female"
                  name="radio-buttons-group"
                  className="p-0 m-0"
                >
                  {decisions?.map((_decision, index) => (
                    <FormControlLabel
                      key={index + _decision.id}
                      value={_decision.id}
                      control={<Radio />}
                      label={_decision.name}
                      onChange={() => {
                        setFormData({
                          ...formData,
                          statusId: _decision?.id,
                        });
                        setDecision(_decision);
                      }}
                      checked={+decision?.id === +_decision?.id}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
              {errors.statusIdError && (
                <small className="text-danger mb-1">
                  Please choose one option above.
                </small>
              )}
            </div>

            <div className="p-0 mt-2">
              <TextField
                error={errors.reasonHasError}
                fullWidth
                size="small"
                name="reason"
                required={true}
                multiline
                rows={3}
                value={formData.reason}
                label={`Reason`}
                placeholder={`Reason`}
                inputProps={{ maxLength: 300 }}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    reason: e.target.value,
                  });

                  setErrors({
                    ...errors,
                    reasonHasError: false,
                  });
                }}
              />
              <small className="text-right float-right text-primary w-100">
                Should not exceed the 300-character limit.
              </small>
              {errors.reasonHasError && (
                <small className="text-danger mb-1">Reason is required</small>
              )}
            </div>
            <br />
          </CardContent>
          <Divider />
          <CardActions className="py-3">
            <div className="d-flex justify-content-between align-items-center flex-wrap w-100">
              <div className="flex-grow-1 text-center">
                <Button
                  disabled={!decision || isLoading}
                  variant="contained"
                  color="success"
                  onClick={() => {
                    if (!formValidator()) {
                      onConfirmReportedAdvert(formData, (isLoading, data) => {
                        setIsLoading(isLoading);
                        if (data) {
                          handleClose();
                        }
                      });
                    }
                  }}
                >
                  {isLoading ? "Wait.." : "Confirm"}
                </Button>
              </div>
            </div>
          </CardActions>
        </Card>
      </Popover>
    </>
  );
};
